module.exports = __webpack_public_path__ + "img/credit_construction.f2ba28b6.png";